<template>
    <div>
		<action-sidebar
			title=""
			:value="true"
			:width="400"
			@close-modal="closeModal"
		>
			<div class="new-type-form-container">
				<h2
					:style="`color:${$appColors.primary}`"
				>{{titleModal}}</h2>
				<form>
					<label for="new-tool-name" class="name-input"
						:style="`color:${$appColors.info}`"
					>
						Descripción
						<input
							class="new-survey-input" 
							placeholder="Descripción"
							v-model="newLevel.name"
						/>
					</label>
					<label for="new-tool-name" class="name-input"
						:style="`color:${$appColors.info}`"
					>
						Definición
						<textarea
							class="new-survey-input"
							rows="5"
							placeholder="Descripción General"
							v-model="newLevel.generalDescription"
						/>
					</label>
					<div>
						<label for="new-tool-name" class="name-input">
							<v-checkbox
								hide-details
								class="question-check checkbox"
								label="Descripción (1era persona)"
								color="success"
								v-model="showDescriptionPerson">
							</v-checkbox>
						</label>
						<label for="new-tool-name" class="name-input"
							:style="`color:${$appColors.info}`"
							v-if="showDescriptionPerson"
						>
							<input
								class="new-survey-input" 
								placeholder="Descripción"
								v-model="newLevel.descriptionFirstPerson"
							/>
						</label>
					</div>
					<label for="new-tool-name" class="name-input">
						Ícono
						<file-load-input
							placeholder="ícono"
							allowed-file-extensions=".svg, .png, .jpg, .jpeg"
							v-model="newLevel.icon"
						/>
					</label>
					<v-checkbox
						v-if="!id"
						hide-details
						class="question-check"
						label="Es pregunta"
						color="success"
						v-model="newLevel.flagQuestion"
					></v-checkbox>
				</form>
				<div class="modal-btn-container">
					<app-button
						class="close-btn"
						text="Cancelar"
						:style="`background-color:${$appColors.error}`"
						@click="closeModal"
					/>
					<app-button
						:disabled="$v.$invalid"
						class="close-btn"
						text="Guardar"
						:style="`background-color:${$appColors.primary}`"
						@click="saveType"
					/>
				</div>
			</div>
		</action-sidebar>
    </div>
</template>
<script>
import actionSidebar from '@/components/shared/action-sidebar';
import appButton from '@/components/shared/app-button';
import fileLoadInput from '@/components/shared/load-file-input';
import { required } from 'vuelidate/lib/validators';

function created() {
	const { name, flagQuestion, id, additionalInformation, description } = this.$route.params;
	this.id = id || 0;
	if (id) {
		this.newLevel = {
			icon: '',
			flagQuestion: Boolean(flagQuestion),
			name,
			generalDescription: description,
			descriptionFirstPerson: additionalInformation &&
				additionalInformation.firstPerson ? additionalInformation.firstPerson : null,
		};
		this.showDescriptionPerson = additionalInformation &&
			additionalInformation.flagDescriptionFirstPerson ?
			additionalInformation.flagDescriptionFirstPerson : null;
	}
}

function closeModal() {
	this.goTo('levels-tool');
}

function titleModal() {
	return this.id ? 'Edición de nivel' : 'Nuevo nivel';
}

async function saveType() {
	const message = this.id ? 'actualizado' : 'creado';
	const body = this.id ? this.buildBodyToEdit() : this.buildBody();
	const service = this.id ? 'editLevel' : 'createLevel';
	try {
		await this.$store.dispatch(`tool/${service}`, body);
		this.showNotification(
			`El nivel: "${this.newLevel.name}", fue ${message} con éxito`,
			'success',
		);
		this.closeModal();
	} catch (error) {
		this.showGenericError();
	}
}

function buildBodyToEdit() {
	const { toolCode, id } = this.$route.params;
	const body = {
		id,
		toolCode,
		name: this.newLevel.name,
		description: this.newLevel.generalDescription,
		urlImage: this.newLevel.icon,
		additionalInformation: this.showDescriptionPerson
			? {
				flagDescriptionFirstPerson: this.showDescriptionPerson,
				firstPerson: this.newLevel.descriptionFirstPerson,
			} : {
				flagDescriptionFirstPerson: this.showDescriptionPerson,
				firstPerson: this.newLevel.descriptionFirstPerson,
			},
	};
	return body;
}

function buildBody() {
	const { number, toolCode, hierarchyFatherId } = this.$route.params;
	const body = {
		toolCode,
		hierarchyFatherId: Number(hierarchyFatherId),
		data: [{
			flagQuestion: Number(this.newLevel.flagQuestion),
			name: this.newLevel.name,
			description: this.newLevel.generalDescription,
			number,
			urlImage: this.newLevel.icon,
			additionalInformation: this.showDescriptionPerson
				? {
					flagDescriptionFirstPerson: this.showDescriptionPerson,
					firstPerson: this.newLevel.descriptionFirstPerson,
				} : {
					flagDescriptionFirstPerson: this.showDescriptionPerson,
					firstPerson: this.newLevel.descriptionFirstPerson,
				},
		}],
	};
	return body;
}

function getFileInfo() {}

function validations() {
	return {
		newLevel: {
			name: { required },
			generalDescription: { required },
			// descriptionFirstPerson: { required },
		},
	};
}

function data() {
	return {
		id: 0,
		newLevel: {
			icon: '',
			flagQuestion: false,
			name: '',
			generalDescription: '',
			descriptionFirstPerson: '',
		},
		showDescriptionPerson: false,
	};
}

export default {
	name: 'new-level-form',
	components: {
		actionSidebar,
		appButton,
		fileLoadInput,
	},
	computed: {
		titleModal,
	},
	created,
	data,
	methods: {
		buildBody,
		buildBodyToEdit,
		closeModal,
		getFileInfo,
		saveType,
	},
	validations,
};
</script>
<style lang="scss" scoped>
.new-type-form-container {
	background-color: color(gray-light);
	height: 100%;
	padding: 0 25px;

	h2 {
		border-bottom: 1px solid color(gray-slider);
		font-family: font(bold);
		font-size: size(xlarge);
		margin-bottom: 20px;
		padding: 10px 0;
	}

	form {
		.name-input {
			flex: 1 1 10%;
			font-family: font(regular);
			font-size: size(small);

			input {
				margin-bottom: 25px;
			}
			.checkbox {
				margin-bottom: 25px;
			}
		}
	}

	.modal-btn-container {
		background-color: white;
		bottom: 0;
		display: flex;
		justify-content: center;
		left: 0;
		padding: 20px;
		position: fixed;
		width: 100%;
		
		.close-btn {
			border-radius: 5px;
			color: white;
			margin: 0 5px;
			padding: 5px 30px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/tools/new-level-form.vue